import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'truncate' })
export class TruncatePipe implements PipeTransform {
  public transform(value: string, maxLength: number, truncateFromMid: boolean = false): string {
    if (typeof value === 'string') {
      const separator = '...';
      const separatorLength = separator.length;
      if (value.length <= maxLength) return value;
      else if (!truncateFromMid) return `${value.substr(0, maxLength - separatorLength)}${separator}`;
      else {
        const charsToShow = maxLength - separatorLength;
        const frontChars = Math.ceil(charsToShow / 2);
        const backChars = Math.floor(charsToShow / 2);
        return value.substr(0, frontChars) + separator + value.substr(value.length - backChars);
      }
    }
    return '';
  }
}
